import React from 'react';
import RadioButton from '../../RadioButton';
import Checkbox from '../../Checkbox';

const Selection = (props) => (data, { key }) => {
    const { type, selectedRowKeys = [], onChange = () => null } = props;
    const checked = selectedRowKeys.includes(key);
    const Select = type === 'checkbox' ? Checkbox : RadioButton;

    return (
        <div className="row-selection">
            <Select
                label=""
                checked={checked}
                onChange={() => onChange(key)}
            />
        </div>
    );
};


export default Selection;
